import { useEffect, useState } from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../redux/store";
import { GetIntegrationSetting } from "../../redux/features/integration-setting/integration-setting-slice";

import AppCard from "./AppCard";
import AppIntegrationModal from "./AppIntegrationModal";

import TherapyPMSLogo from "../../assets/images/integration-apps/therapypms.png";
// import MotivityLogo from "../../assets/images/integration-apps/motivity.png";
import GmailLogo from "../../assets/images/integration-apps/GmailLogo.png";
import OutlookLogo from "../../assets/images/integration-apps/outlook.png";
import CentralReachLogo from "../../assets/images/integration-apps/centralreach.jpg";
import TextGridLogo from "../../assets/images/integration-apps/Textgrid.png";
import MessageLogo from "../../assets/images/integration-apps/message.png";
// import SyncRequest from "./SyncRequest";
import {
  ConnectMailBox,
  DisConnectMailbox,
  GetActiveMailboxProvider,
} from "src/redux/features/mailBox/mailbox-slice";
import { IMailBoxAuthData } from "src/types/mail";
import Close from "@mui/icons-material/Close";
import { getTenantPlan } from "src/redux/features/plan-billing/plan-billing-slice";
import { ICurrentPlan } from "src/types/product";
import { setResponseValue } from "src/redux/features/api-response/api-response";
import SyncRequest from "./SyncRequest";
import { TextGridStatus } from "src/types/company";

const AppIntegrations = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedApp, setSelectedApp] = useState<string>("");
  const [selectedTab, setSelectedTab] = useState<string>();
  const [selectedMailBox, setSelectedMailBox] = useState<string>("");
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const integrationSetting = useAppSelector(
    (state) => state.integrationSettingSlice.integrationSettings
  );
  const mailBoxAuthData = useAppSelector<IMailBoxAuthData | null>(
    (state) => state.mailBoxSlice.mailBoxAuthData
  );

  const currentPlan = useAppSelector<ICurrentPlan>(
    (state) => state.planBillingSlice.currentPlan
  );

  const textGridStatus = useAppSelector<string>(
    (state) => state.organizationSlice.orgData.textGridSetting.status
  );

  const handleOpenModal = (appName: string) => {
    setIsModalOpen(true);
    setSelectedApp(appName);
  };

  const hasValidCredential = (appName: string) =>
    integrationSetting.some(
      (setting) =>
        setting.appName.toLowerCase() === appName.toLowerCase() &&
        ((typeof setting.credential === "string" &&
          setting.credential.trim() !== "") ||
          (typeof setting.credential === "object" &&
            Object.keys(setting.credential).length !== 0))
    );

  const handleSelectTab = (tab: string) => {
    setSelectedTab(tab);
    if (tab === "Connect") {
      localStorage.removeItem("selectedIntegrationTab");
    } else {
      localStorage.setItem("selectedIntegrationTab", tab);
    }
  };

  const handleConnectMailBox = async (mailboxProvider: string) => {
    if (currentPlan?.addons.mailbox?.priceId) {
      const data = await dispatch(ConnectMailBox({ mailboxProvider }));
      if (data.payload?.authUrl) {
        window.location.href = data.payload?.authUrl;
      }
    } else {
      dispatch(setResponseValue({ name: "error", value: true }));
      dispatch(
        setResponseValue({
          name: "message",
          value: "Please purchase Mailbox Add-on first. ",
        })
      );
    }

    return;
  };

  useEffect(() => {
    const storedTab = localStorage.getItem("selectedIntegrationTab");
    if (storedTab) {
      setSelectedTab(storedTab);
    } else {
      setSelectedTab("Connect");
    }
    dispatch(GetIntegrationSetting());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //get active mailbox provider data
    dispatch(GetActiveMailboxProvider());

    //get current plan
    dispatch(getTenantPlan());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log("integrationSetting", integrationSetting);
  console.log(textGridStatus, "textGridStatus");

  return (
    <div className="pageTemplate">
      <Typography
        gutterBottom
        variant="h6"
        component="div"
        className="cardBlock__title"
        sx={{ marginBottom: "20px" }}
      >
        App Integration
      </Typography>
      <div className="pageTemplate-top" style={{ width: "fit-content" }}>
        <ul className="innerTabs mb-tab">
          <li className="innerTabs__item form-tabs">
            <button
              onClick={() => handleSelectTab("Connect")}
              className={selectedTab === "Connect" ? "active" : ""}
            >
              Connect
            </button>
          </li>
          <li
            className="innerTabs__item form-tabs"
            onClick={() => {
              handleSelectTab("TherapyPMS");
            }}
          >
            <button className={selectedTab === "TherapyPMS" ? "active" : ""}>
              TherapyPMS
            </button>
          </li>

          <li
            className="innerTabs__item form-tabs"
            onClick={() => handleSelectTab("CentralReach")}
          >
            <button className={selectedTab === "CentralReach" ? "active" : ""}>
              CentralReach
            </button>
          </li>

          {/* <li
            className="innerTabs__item form-tabs"
            onClick={() => handleSelectTab("Motivity")}
          >
            <button className={selectedTab === "Motivity" ? "active" : ""}>
              Motivity
            </button>
          </li> */}
        </ul>
      </div>

      {selectedTab === "Connect" && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "40px" }}>
          <AppCard
            appName="TherapyPMS"
            connected={hasValidCredential("therapypms")}
            logo={TherapyPMSLogo}
            onClick={() => handleOpenModal("TherapyPMS")}
            description={
              "Connect your ABA Engine acount. Create or edit client files, employee files, and authorizations in TherapyPM. Creating and editing schedules is currently not available."
            }
          />
          <AppCard
            appName="CentralReach"
            connected={hasValidCredential("CentralReach")}
            logo={CentralReachLogo}
            onClick={() => handleOpenModal("CentralReach")}
            description={
              "Connect your ABA Engine account. Create or edit client files, employee files, and authorizations in CR. Currently CR does not allow schedule creation or editing from outside apps."
            }
          />
          <AppCard
            appName="Gmail"
            connected={
              mailBoxAuthData && mailBoxAuthData.provider === "google"
                ? true
                : false
            }
            logo={GmailLogo}
            onClick={() => {
              if (!mailBoxAuthData) {
                handleConnectMailBox("google");
              } else {
                setOpenPopup(true);
                setSelectedMailBox("google");
              }
            }}
            description={
              "Connect your Gmail account to ABAEngine, so that you can sync your Gmail events to ABAEngine."
            }
          />
          <AppCard
            appName="Outlook"
            connected={
              mailBoxAuthData && mailBoxAuthData.provider === "microsoft"
                ? true
                : false
            }
            logo={OutlookLogo}
            onClick={() => {
              if (!mailBoxAuthData) {
                handleConnectMailBox("microsoft");
              } else {
                setOpenPopup(true);
                setSelectedMailBox("microsoft");
              }
            }}
            description={
              "Connect your Outlook account to ABAEngine, so that you can sync your Outlook events to ABAEngine."
            }
          />
          <AppCard
            appName="TextGrid"
            connected={textGridStatus === TextGridStatus.Connected}
            logo={MessageLogo}
            onClick={() => {}}
            description={
              // "Request setup for TextGrid, so that you can enable sms feature in ABAEngine."
              "Request SMS setup to activate and start using the SMS feature seamlessly within ABAEngine for enhanced communication."
            }
            textGridStatus={textGridStatus}
          />
          {/* Request to turn off motivity - by Hui 4.14.2025
            <AppCard
            appName="Motivity"
            connected={hasValidCredential("motivity")}
            logo={MotivityLogo}
            onClick={() => handleOpenModal("Motivity")}
          /> */}
        </Box>
      )}
      {selectedTab === "TherapyPMS" && <SyncRequest appName="TherapyPMS" />}
      {/* {selectedTab === "Motivity" && <SyncRequest appName="Motivity" />} */}
      {selectedTab === "CentralReach" && <SyncRequest appName="CentralReach" />}

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",                   
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Typography>Allow to integrate applications</Typography>
        <FormControlLabel
          className="customToggler"
          control={
            <Switch
              onClick={handleSwitch}
              checked={integrationSetting.isActive}
            />
          }
          label={integrationSetting.isActive ? "ON" : "OFF"}
        />
      </Box> */}
      {isModalOpen && (
        <AppIntegrationModal
          appName={selectedApp}
          isModalOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
        />
      )}
      <Dialog open={openPopup} className="smallModel--intakeforms">
        <Box className="smallModel__head" style={{ padding: "12px 16px" }}>
          <Typography variant="h3" className="smallModel__title">
            Confirmation
          </Typography>
          <Button
            className="smallModel__closeBtn"
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            <Close />
          </Button>
        </Box>
        <Box className="mailbox-connection-content">
          <Typography className="text">
            Your Mailbox is currently connected to{" "}
            {mailBoxAuthData?.provider === "google"
              ? "Gmail"
              : mailBoxAuthData?.provider === "microsoft"
              ? "Outlook"
              : ""}
            . Connecting another mailbox will disconnect the current one.
          </Typography>
        </Box>
        <Box className="mailbox-connection-footer">
          <Button
            variant="contained"
            // className="button"
            onClick={async () => {
              setOpenPopup(false);
              if (mailBoxAuthData) {
                await dispatch(
                  DisConnectMailbox({
                    mailboxId: mailBoxAuthData?.id,
                  })
                );
                handleConnectMailBox(selectedMailBox);
              }
            }}
          >
            Connect
          </Button>
        </Box>
      </Dialog>
    </div>
  );
};

export default AppIntegrations;
